module.exports = __webpack_public_path__ + "static/media/LeftArrow.42581a3a.svg";